import React, { useContext, useEffect } from 'react';
import { Route, useLocation } from 'react-router-dom';
import { firebaseAuth } from '../provider/AuthProvider';
import { AuthRedirect } from '../components/AuthPanel';
import SessionStatus from '../components/SessionStatus';
import { rememberDestination, loginDestination } from './navigation';

export default function GuestRoute({ component: Component, ...rest }) {
  const { loading, currentUser, sessionStatus } = useContext(firebaseAuth);
  const location = useLocation();
  useEffect(() => {
    if (!currentUser && location.state && location.state.from) {
      rememberDestination({ pathname: loginDestination(location) });
    }
  }, [currentUser, location]);
  return <Route {...rest} render={props => {
    if (loading || sessionStatus === 'error') return <SessionStatus />;
    return currentUser ? <AuthRedirect /> : <Component {...props} />;
  }} />;
}
